import styled from 'styled-components';

export const SearchContainerStyled = styled.div`
  .ant-input-wrapper {
    display: flex;
  }

  * {
    margin: 0;
  }

  .ant-select {
    width: 100%;
    &::before {
      border-style: none !important;
    }
    &::after {
      border: none !important;
    }
  }

  & .ant-input-group-addon {
    width: auto;
  }

  .ant-input-search-button {
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & input {
    height: 36px;
  }

  .ant-input-group-wrap {
    width: auto;
  }
`;
